<script lang="ts">
  import Button from '$components/elements/Button.svelte';
  import Icon from '$components/elements/Icon.svelte';
  import Modal from '$components/elements/Modal.svelte';
  import ModalImageHeader from '$components/elements/ModalImageHeader.svelte';
  import Flex from '$components/layout/Flex.svelte';
  import Grid from '$components/layout/Grid.svelte';
  import { pbClient } from '$lib/client/pocketbase';
  import { getPledgeData } from '$lib/client/pocketbase/pledge';
  import { showPledge, pledgeInfo } from '$lib/stores';
  import { globalValues } from '$lib/stores/global-values';
  import { onMount } from 'svelte';

  function copy(string: string) {
    navigator.clipboard.writeText(string);
  }

  onMount(async () => {
    pledgeInfo.set(await getPledgeData());
  });
  pbClient.authStore.onChange(async () => {
    pledgeInfo.set(await getPledgeData());
  });

  $: bankAccount = $globalValues.accountNumber;
  $: variableSymbol = $pledgeInfo?.variableSymbol;
  $: amount = $pledgeInfo?.amount;
</script>

<Modal width="1120px" showModal={$showPledge}>
  <ModalImageHeader>
    <svg
      width="122"
      height="122"
      viewBox="0 0 122 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2227_5937)">
        <path
          d="M0 60.6416C0.716243 59.3762 1.79061 58.9465 3.24697 58.9704C7.3773 59.042 11.4838 59.0659 15.6141 58.9704C19.2431 58.8987 21.8932 60.3074 23.4211 63.7453C27.4798 63.7453 31.5624 63.7214 35.645 63.7453C37.8654 63.7692 40.1096 63.6021 42.2822 63.9602C44.4309 64.3183 46.6035 65.0346 48.5374 66.0134C52.5483 68.0666 56.416 70.4064 60.3793 72.579C61.0955 72.9848 62.0027 73.2236 62.8384 73.2236C67.2791 73.2952 71.7198 73.4385 76.1605 73.1997C82.6544 72.8655 87.6681 77.4733 87.0474 84.397C88.3843 83.9434 89.6736 83.5136 90.9628 83.06C96.9793 80.9829 103.02 78.9297 109.036 76.8287C110.994 76.1602 112.951 75.9214 114.981 76.4228C118.849 77.4017 121.427 80.4576 121.809 84.4686C122.167 88.2886 120.042 91.9892 116.461 93.6126C110.063 96.4776 103.64 99.271 97.2419 102.088C88.7425 105.837 80.243 109.633 71.7198 113.333C61.9072 117.583 52.3573 116.891 43.1656 111.471C39.274 109.179 35.4063 106.839 31.5624 104.5C29.2466 103.091 26.6681 102.47 24.0419 102.064C23.7793 102.017 23.3018 102.279 23.1585 102.542C21.6067 105.359 19.2192 106.601 16.02 106.553C11.7464 106.481 7.44892 106.505 3.17534 106.553C1.74286 106.577 0.716242 106.123 0.0716241 104.858C-1.84996e-07 90.1269 0 75.3962 0 60.6416ZM23.827 97.3132C28.6258 97.743 32.78 99.5813 36.6955 102.112C39.5843 103.974 42.5687 105.693 45.553 107.436C53.3123 112.02 61.382 112.665 69.6665 109.06C81.0548 104.094 92.4192 99.0561 103.784 94.0663C107.341 92.5144 110.898 90.9625 114.432 89.3629C116.389 88.4796 117.368 86.4502 116.939 84.4686C116.485 82.3438 115.029 81.0545 112.856 81.0068C112.044 80.9829 111.209 81.1739 110.421 81.4365C101.348 84.5402 92.2759 87.5723 83.2751 90.8432C80.2669 91.9414 77.2826 92.3711 74.1072 92.3234C67.4939 92.2279 60.8568 92.2995 54.2434 92.2995C53.8376 92.2995 53.4556 92.3234 53.0497 92.2757C51.9515 92.1324 51.092 91.249 50.9726 90.1508C50.8532 89.1003 51.474 88.0737 52.5245 87.7395C53.0497 87.5723 53.6227 87.5484 54.1479 87.5484C61.8834 87.5484 69.6188 87.5484 77.3303 87.5484C79.5507 87.5484 81.3174 86.307 81.9859 84.3492C83.0603 81.2216 80.7922 78.094 77.3781 78.0463C72.5076 77.9985 67.6372 77.9985 62.7429 78.0463C61.0239 78.0702 59.472 77.6404 57.9918 76.8048C54.1718 74.6322 50.328 72.5074 46.508 70.3348C44.3593 69.0933 42.0673 68.4964 39.5843 68.5203C34.7139 68.5441 29.8434 68.5203 24.9491 68.5203C24.5671 68.5203 24.1851 68.5441 23.7554 68.568C23.827 78.1418 23.827 87.6439 23.827 97.3132ZM4.8227 101.802C8.69041 101.802 12.4149 101.802 16.1393 101.802C18.1926 101.802 19.0521 100.966 19.0521 98.9367C19.0521 88.1692 19.0521 77.3778 19.0521 66.6103C19.0521 64.6526 18.1687 63.7692 16.211 63.7692C12.6775 63.7453 9.16791 63.7692 5.63444 63.7692C5.37182 63.7692 5.1092 63.8408 4.84658 63.8647C4.8227 76.4944 4.8227 89.0764 4.8227 101.802Z"
          fill="black"
        />
        <path
          d="M70.8607 58.9228C73.3914 56.7502 75.8982 54.6731 78.3096 52.5243C82.6548 48.6328 87 44.7651 91.202 40.7302C93.8759 38.1756 96.1679 35.2629 97.6482 31.8249C99.7014 27.0261 99.6059 22.2273 97.1229 17.6195C92.7061 9.47816 82.0579 8.57093 76.4474 15.9243C75.0149 17.8105 74.0599 20.0786 73.0094 22.2512C72.3409 23.6359 71.744 24.3044 70.5503 24.3044C69.3566 24.3044 68.6164 23.6836 68.1628 22.2273C67.3033 19.5772 66.0141 17.2136 64.128 15.1842C57.9444 8.54705 47.8932 9.97953 43.7867 18.097C43.3331 19.0042 43.0227 20.0069 42.6168 20.938C42.0916 22.1318 40.8501 22.6809 39.6802 22.2512C38.4865 21.8214 37.818 20.6277 38.1761 19.3862C41.447 8.1173 52.5965 3.8676 61.3346 7.42494C64.7965 8.83355 67.3988 11.2688 69.4759 14.3009C69.8341 14.8261 70.1683 15.3514 70.5742 15.9721C70.9323 15.423 71.2427 14.9455 71.5769 14.468C75.8744 8.2128 81.6998 5.08521 89.292 6.54157C96.9319 8.02181 101.42 13.0594 103.235 20.4606C104.811 26.8829 103.283 32.7799 99.5343 38.1517C95.9769 43.2609 91.393 47.439 86.7374 51.5216C82.1534 55.5564 77.4979 59.5196 72.89 63.4829C71.3143 64.8198 70.3832 64.8198 68.8313 63.4829C62.3374 57.8962 55.7957 52.3811 49.3973 46.6989C47.0575 44.6218 45.0521 42.2105 42.975 39.8707C41.7812 38.5337 41.8767 37.1251 42.9988 36.194C44.1448 35.2629 45.5534 35.5255 46.6994 36.9341C50.9014 42.1627 56.0583 46.3647 61.1198 50.7099C64.2951 53.4077 67.5182 56.1056 70.8607 58.9228Z"
          fill="black"
        />
        <path
          d="M42.5684 29.4618C42.5922 30.7272 41.5895 31.8254 40.3003 31.8731C38.9871 31.9209 37.8412 30.8943 37.8173 29.5573C37.7934 28.2681 38.8916 27.1221 40.2048 27.1221C41.4701 27.1459 42.5445 28.1964 42.5684 29.4618Z"
          fill="black"
        />
        <path
          d="M11.8913 73.2482C10.6021 73.2482 9.5516 72.2215 9.52773 70.9323C9.50385 69.6431 10.6021 68.4971 11.9152 68.4971C13.1806 68.4971 14.2549 69.5476 14.2788 70.8129C14.3027 72.1738 13.2044 73.2482 11.8913 73.2482Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2227_5937">
          <rect width="122" height="122" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </ModalImageHeader>
  <div class="donation-pledge">
    <h2>Nastavte si prosím příkaz k úhradě</h2>
    <p>Přihlaste se do Vašeho internetového bankovnictví a zadejte Váš příkaz k úhradě.</p>
    {#if $pledgeInfo}
      <Flex
        width="100%"
        justifyContent="center"
        breakpoints={{
          0: {
            direction: 'column',
            gap: '24px'
          },
          720: {
            direction: 'row',
            gap: '34px'
          }
        }}
      >
        <div class="donation-pledge__info">
          <h3>Vaše dárcovské údaje:</h3>
          <Grid templateColumns="auto 1fr" gap="6px" margin="0 auto">
            <strong class="color-caramel">Číslo účtu:</strong><span
              on:click={() => copy(bankAccount)}
              on:keypress={() => copy(bankAccount)}
              >{bankAccount}<Icon size={20} icon="copy" cursor="pointer" /></span
            >
            <strong class="color-caramel">Variabilní symbol:</strong><span
              on:click={() => copy(`${variableSymbol}`)}
              on:keypress={() => copy(`${variableSymbol}`)}
              >{variableSymbol}<Icon size={20} icon="copy" cursor="pointer" /></span
            >
            <strong class="color-caramel">Částka:</strong><span
              on:click={() => copy(`${amount}`)}
              on:keypress={() => copy(`${amount}`)}
              >{amount}&nbsp;Kč<Icon size={20} icon="copy" cursor="pointer" /></span
            >
          </Grid>
        </div>
      </Flex>
    {/if}
    <p>
      Údaje jsme Vám právě odeslali i e-mailem. Až budete mít příkaz k úhradě nastaven, prosím
      potvrďte stisknutím tlačítka níže.
    </p>
    <Button on:click={() => showPledge.set(false)} width="min(460px, 90vw)">Hotovo</Button>
  </div>
</Modal>

<style lang="scss">
  .donation-pledge {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding: 24px 83px 50px;
    h2 {
      font-size: 24px;
      text-align: center;
    }
    p {
      font-size: 16px;
      text-align: center;
    }
    &__info {
      width: 100%;
      max-width: 500px;
      border: 1px solid $color-medium-gray;
      padding: 39px 36px;
      border-radius: 13px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      align-items: center;
      justify-content: center;
      h3 {
        font-size: 24px;
        text-align: center;
      }
      strong,
      span {
        font-weight: 800;
        font-size: 20px;
      }
      strong {
        margin-left: auto;
        text-align: right;
      }
      span {
        display: flex;
        gap: 6px;
        align-items: center;
      }
    }
  }
  @include mobile {
    .donation-pledge {
      padding: 24px 0 50px;
      gap: 32px;
      h2 {
        font-size: 28px;
        font-weight: 800;
      }
      &__info {
        width: 90vw;
        padding: 30px 8px;
        h3 {
          font-size: 20px;
        }
        strong,
        span {
          font-size: 16px;
        }
      }
    }
  }
</style>
